import { IpType } from "src/patents/patents"

export function createStandardizedPatentNumber({countryCode, ipType}: {countryCode: string, ipType?: IpType}, rawPatentNumber: string): string {
  let trimmed = rawPatentNumber.trim()
  //if (trimmed.startsWith(countryCode)) {
  //  return trimmed
  //}
  trimmed = trimmed.replace(/[\s]/g, '').toUpperCase()
  const secondLast = trimmed[trimmed.length-2]
  if (secondLast === '-' || secondLast === '.') {
    trimmed = trimmed.slice(0, -2)
  }
  if (trimmed.startsWith('PCT/EP')) {
    trimmed = trimmed.replace('PCT/EP', '')
  }
  trimmed = trimmed.replace(/^[A-Z]{1,2}/g, '')
  trimmed = trimmed.replace(/[A-C][0-9]?$/g, '') // let's keep suffix if it is a utility model or design or similar
  // Remove prefix indicating ip type in some countries
  trimmed = trimmed.replace(/^[/-]{0,1}[0-9A-Za-z]{1,2}[-/]/g, '')
  trimmed = trimmed.replace(/[/,-]/g, '')

  if (trimmed.length <= 1) return ''

  const _cc = countryCode === 'UP' ? 'EP' : countryCode

  const _kind = (ipType === 'utility-model') ? 'U1' : ''

  return _cc + trimmed + _kind
}

export function deduceIpType(ipTypeStr: string): IpType | undefined {
  const lc = ipTypeStr.toLowerCase()
  if (lc.includes('utility')) return 'utility-model'
  if (lc.includes('patent')) return 'patent'
  return undefined
}

export function standardizeCountryCode(rawCountryCode: string): string {
  const ccup = rawCountryCode.toUpperCase()
  switch (ccup) {
    case 'UP':
      return 'EP'
    case 'INT': 
    case 'PCT': 
      return 'WO'
    default:
      return ccup
  }
}